// extracted by mini-css-extract-plugin
export default {"pagebreak":"printStyle_pagebreak__HqzVC","setfontsize":"printStyle_setfontsize__ncMNg","unbreakable":"printStyle_unbreakable__2dAnS","bodyStyle":"printStyle_bodyStyle__VpiFF"};